<template>
  <div class="pa-2 mt-4">
    <v-card class="pa-4" flat outlined>
      <v-tabs v-model="tabs" grow>
        <v-tab>
          <v-icon class="mx-2">mdi-link-plus</v-icon>
          ارسال لینک‌ها به صورت دستی
        </v-tab>

        <v-tab>
          <v-icon class="mx-2">mdi-file-upload</v-icon>
          ارسال لینک‌ها با فایل
        </v-tab>
      </v-tabs>
      <v-divider class="ms-2" />
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <!--دستی-->
          <v-card class="pa-2 rounded-lg" flat outlined>
            <v-card-title class="pa-2">
              ساخت لینک کوتاه گروهی
              <v-icon>mdi-link</v-icon>
              <v-divider class="ms-2" />
            </v-card-title>
            <v-progress-linear
              v-if="formLoading"
              indeterminate
              color="navy"
              class="mb-4"
            ></v-progress-linear>
            <v-row class="mt-4" no-gutters>
              <v-col cols="12" md="6" class="px-2">
                <v-text-field
                  v-model="TitleUrl"
                  class="rounded-lg v-input--dense pa-0 ma-0"
                  outlined
                  dense
                  label="عنوان"
                  validate-on-blur
                  :rules="[rules.max]"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  hint="لطفا یک نام برای لینک کوتاه خود اضافه کنید."
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-2">
                <v-select
                  outlined
                  :items="domains"
                  v-model="selectedDomain"
                  class="rounded-lg v-input--dense pa-0 ma-0"
                  label="دامنه"
                  dense
                  :rules="[rules.required_domain]"
                  :loading="Domainloading"
                  hint="لطفا یک دامنه انتخاب کنید"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="mt-4" no-gutters>
              <v-col cols="12" class="px-2">
                <v-textarea
                  v-model="longUrlsText"
                  class="rounded-lg v-input--dense pa-0 ma-0"
                  outlined
                  dense
                  label="لینک"
                  validate-on-blur
                  :rules="[rules.required, rules.urlFormat]"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  hint="لطفا لینک‌های مورد نظر خود را وارد کنید (در هر خط یک لینک وارد شود.)."
                  placeholder=" مانند http://www.google.com"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <v-divider />
              </v-col>
            </v-row>
            <v-row class="mt-4" no-gutters>
              <v-col cols="12">
                <v-btn
                  :disabled="!checkRules"
                  class="btn-send-sms btn"
                  :loading="loading"
                  color="success"
                  depressed
                  @click="createGrouplinks(longUrls)"
                  >ساخت لینک کوتاه
                  <v-icon>mdi-link-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <!--show message-->
          <v-snackbar
            v-model="snackbar"
            :timeout="3000"
            :color="snackbarColor"
            top
          >
            {{ snackbarText }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
        </v-tab-item>
        <v-tab-item>
          <send-file />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-dialog v-model="dialog" max-width="300px" max-height=" 600px">
      <v-card>
        <div class="text-center py-2">
          <v-card-title
            class="d-block font-weight-bold font-size-h5 mt-2 word-break text-message"
            >در غیر اینصورت دستی ویرایش کنید. لینک‌ها اشتباه حذف شوند، مابقی
            لینک‌ها کوتاه شود؟
          </v-card-title>
        </div>

        <v-card-text class="mt-0 pt-1 mb-0 pb-0 mx-2 rightFlexDirection">
          <p style="color: red" v-for="(url, index) in listNoUrls" :key="index">
            {{ url }}
          </p>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn color="green" @click="confirmurl" class="white--text">
            <v-icon>mdi-check</v-icon>بله
          </v-btn>

          <v-btn color="red" @click="dialog = false" class="white--text">
            <v-icon>mdi-close</v-icon> خیر
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import sendFile from "./sendFile.vue";
import "@/assets/css/style.shortlink.css";

import {
  GetDomain,
  GetLink,
  GetMultilink,
  DeleteLink,
  AddLink,
  EditLink,
  savetoken,
  AddMultilink,
} from "./axios_shortlink.js";
import {
  removehttp,
  checkUrl,
  isValidUrl,
  readLinksFromXlsxFile,
  readLinksFromCsvFile,
  readLinksFromTextFile,
  validateLink,
  filterCorrectLinks,
  isLinkInText,
  convertTableToCsv,
  IsValidUrl2,
  downloadCvsFile,
} from "@/assets/js/FunctionLink.js";

export default {
  components: { sendFile },
  name: "addNewGroupShortLink",
  data() {
    return {
      listNoUrls: [],
      TitleUrl: "",
      tabs: 0,
      loading: false,
      Domainloading: false,
      formLoading: false,
      dialog: false,
      shortUrls: [],
      longUrlsText: "",
      isDeleteMistakeLink: false,
      domains: [],
      selectedDomain: "t7r.ir",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      rules: {
        required_domain: (value) =>
          !!value?.trim() ? true : "لطفا یک دامنه انتخاب کنید",
        required: (value) => {
          if (typeof value === "string") {
            return !!value?.trim() ? true : "لطفا حداقل یک لینک را وارد کنید";
          }
          return "";
        },
        urlFormat: (value) => {
          let values = value
            ?.trim()
            .split("\n")
            .filter((link) => link.trim() !== "");
          const pattern = new RegExp(
            "^(https?:\\/\\/|www\\.)?" + // پروتکل‌های مختلف یا www
              "(localhost|(([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" + // localhost یا دامین
              "(\\d{1,3}(\\.\\d{1,3}){3}))" + // آی‌پی‌ها
              "(\\:\\d+)?" + // پورت (اختیاری)
              "(\\/[-a-zA-Z\\d%_.~+]*)*" + // مسیر
              "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" + // کوئری پارامتر
              "(\\#(\\/[-a-zA-Z\\d%_.~+]*)?)?$", // هشتگ با مسیر اختیاری
            "i"
          );

          let allvalues = values.every((p) => pattern.test(p));
          return !!value && allvalues ? true : "لینک‌های وارد شده معتبر نیست!";
        },
        max: (value) =>
          !!value && value.length <= 50
            ? true
            : "عنوان بیشتر از 50 حرف نباشد! لطفا عنوان کوتاه‌تری وارد کنید",
      },
    };
  },
  created() {
    this.initData();
  },
  computed: {
    longUrls() {
      return this.longUrlsText
        ?.trim()
        .split("\n")
        .filter((link) => link.trim() !== "");
    },
    checkRules() {
      return (
        this.rules.max(this.TitleUrl?.trim()) === true &&
        // this.rules.urlFormat(this.longUrlsText) === true &&
        this.rules.required(this.longUrlsText) === true &&
        this.rules.required_domain(this.selectedDomain) === true
      );
    },
  },
  methods: {
    initData() {
      this.Domainloading = true;
      GetDomain()
        .then((data) => {
          this.domains = data;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("خطا در دریافت دامنه:", error);
          this.showSnackbar("خطا در بارگذاری دامنه‌ها!", "error");
        })
        .finally(() => {
          this.Domainloading = false;
        });
    },
    isExist(url) {
      url = url?.trim().replace(/\/+$/, "").toLowerCase();
      return this.ShortLinks.some((p) => p.longUrl === url);
    },
    Back() {
      this.longUrlsText = "";
      this.shortUrls = [];
    },
    confirmurl() {
      this.dialog = false;
      this.isDeleteMistakeLink = true;
      let longurls = this.longUrls.filter((p) => !this.listNoUrls.includes(p));
      this.longUrlsText = longurls.join("\n");
      console.log(this.longUrlsText, "this.longUrlsText ");
      this.addLinks(longurls);
      console.log(this.longUrlsText, "exist");
    },
    async createGrouplinks(urls) {
      if (!urls && urls?.length === 0) {
        this.showSnackbar("لطفاً لینک‌ها را وارد کنید.", "error");
        return;
      }
      this.formLoading = true;
      this.listNoUrls = [];
      let invalidUrls = urls.filter((url) => !IsValidUrl2(url));
      this.listNoUrls = invalidUrls;
      if (invalidUrls.length > 0) {
        this.dialog = true;
        // show dialog for select now send delete link message
        //message "لینک‌ها معتبر نیست"
        //for choise "delete"
        if (!this.isDeleteMistakeLink) {
          this.formLoading = false;
          return;
        }
        this.isDeleteMistakeLink = false;
      } else {
        this.addLinks(urls);
      }
      this.formLoading = false;
    },
    addLinks(urls) {
      this.formLoading = true;
      urls = urls.map((url) => checkUrl(url));

      let titles = [];
      for (let i = 0; i < urls.length; i++) {
        titles.push(`${this.TitleUrl}(${i + 1})`);
      }

      AddMultilink({
        links: urls,
        type_id: 1,
        domainId: 1,
        titles: titles,
        created_at: new Date().toISOString().split(".")[0],
      })
        .then((x) => {
          this.$router.push("/shortlink");
        })
        .catch((error) => {
          console.error("خطا در ساخت لینک کوتاه:", error);
          this.$swal({
            title: "خطا!",
            text: "مشکلی در ساخت لینک کوتاه پیش آمد. لطفاً دوباره تلاش کنید.",
            icon: "error",
            confirmButtonText: "باشه",
          });
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    showSnackbar(message, color) {
      this.snackbar = false;
      this.$nextTick(() => {
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbar = true;
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 780px) {
  ::v-deep(.v-btn) {
    margin-top: 10px !important;
    padding-top: 10px !important;
  }
  ::v-deep(.v-text-field) {
    width: 100% !important;
    flex: 1 1 100%;
    margin-bottom: 10px !important;
  }

  ::v-deep(.v-btn) {
    width: 98%;
  }
}

.box {
  background-color: #fff;
  -webkit-box-shadow: 5px 5px 5px #7e8299;
  box-shadow: 5px 5px 5px #7e8299;
  letter-spacing: unset;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 3px;
  padding: 120px 70px 120px 70px;
}
.resultShorturl {
  letter-spacing: unset;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 3px;
}
* {
  box-sizing: border-box;
}
::v-deep(.v-btn) {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.text-message {
  word-break: break-word;
  text-align: justify;
}
</style>
